import { LoadingSpinner } from '@ais-ui/ui-core';
import {
  MakePermissions,
  MappedPermissions,
  useGetPermissions,
} from '@ais-ui/websockets';
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

interface PermissionsProviderProps {
  children: ReactNode;
}

const PermissionsContext =
  createContext<MakePermissions<MappedPermissions> | null>(null);

export const PermissionsProvider = ({ children }: PermissionsProviderProps) => {
  const fetchedPermissions = useGetPermissions();

  const [permissions, setPermissions] =
    useState<MakePermissions<MappedPermissions> | null>(null);

  useEffect(() => {
    if (fetchedPermissions && fetchedPermissions.data) {
      setPermissions(fetchedPermissions.data);
    }
  }, [fetchedPermissions]);

  const content =
    permissions != null ? (
      children
    ) : (
      <LoadingSpinner className="h-screen w-screen" />
    );

  return (
    <PermissionsContext.Provider value={permissions}>
      {content}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error(
      'usePermissionsContext must be used within a PermissionsContextProvider'
    );
  }
  return context;
};
